import { useEffect, useState } from 'react';

/**
 * Current viewport width, kept in sync with `resize`.
 *
 * NPT-1800 — read synchronously on the first render rather than starting at
 * null and filling it in from an effect. The React tree is never rendered on
 * the server (`pages/+config.ts` sets `ssr: false`), so there is no hydration
 * mismatch to avoid here, and a null first render would paint one frame of the
 * wrong layout before snapping — visible as a jump on the org landing hero,
 * where this decides whether the schedule sits beside the search bar.
 */
export function useViewportWidth(): number {
   const [width, setWidth] = useState(() => (typeof window === 'undefined' ? 0 : window.innerWidth));

   useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      // Covers a width that changed between the initial render and this effect.
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []);

   return width;
}
